<template>
  <div class="w-100 buttonImitation totalDonations">
    Aktuelle Unterstützung<br/>{{isFloat(totalStreamDonation)?totalStreamDonation.toFixed(2):totalStreamDonation}} € <span v-if="show_people && totalDonationPeople>=10" class="donatorCount"><br/><i class="icon solid fa-user"></i> {{totalDonationPeople}}</span>
      <div v-if="preview" class="pl-05 pr-05 pb-1">
      <a v-if="!clicked" title="Jetzt spenden" class="w-100 button gsn-donate-button primary icon solid fa-heart"  href="#" @click.prevent="onClick()">{{btnDonateButton}}</a>
    </div>
  </div>
</template>

<script>
import {projectBase} from '@/mixins/projectBase.js'
import {helper} from '@/mixins/helper.js'
export default {
  name: 'RTProjectDonationSum',
  mixins:[projectBase,helper],
  components:{
    
  },
  props:{

    project:{
      type:Object
    },
    preview:{
      type:Boolean,
      default:false
    },
    show_people:{
      type:Boolean,
      default:false
    },
  },
  computed:{
    stream(){
      return this.getLastStreamByProjectId(this.project.id);
    },
    btnDonateButton(){
      return this.isSmallTouchDevice()?"UNTERSTÜTZEN":"JETZT UNTERSTÜTZEN"
    },
    totalStreamDonation(){
      let donations=(this.stream)?this.getStreamDonationsByStreamId(this.stream.id):null;
      console.log(donations);
      return (donations)?donations.sum:0;
    },
    totalDonationPeople(){
      let donations=(this.project)?this.getDonationsByProjectId(this.project.id):null;
      return (donations)?donations.people:0;
    },
  },
  data: function() {
    return {
      clicked:false
    };
  },
  methods:{

    onClick(){
      this.clicked=true;
      this.$emit('click');
    }
  }
};
</script>

<style scoped type='text/css'>
.donatorCount{
  font-size: 0.75em;
}
.gsn-donate-button{
  white-space: normal;
  height: auto;
}
.totalDonations{
  font-size: 2em;
  height:auto!important;
  white-space: normal;
}
@media screen and (max-width: 450px) {
.totalDonations{
  font-size: 1.5em;
  }
  .donationIcon{
    width:80%
  }
}
</style>